import React, { useState } from "react";
import "../App.css";
import { makeStyles } from "@material-ui/core/styles";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 130,
  },
}));

function Genre(props) {
  const classes = useStyles();
  const [sortType, setSortType] = useState("");
  const [activeCategory, setActiveCategory] = useState("All");
  const [ageCategory, setAgeCategory] = useState("All");
  const [isActive, setIsActive] = useState(false);
  const [isActive7, setIsActive7] = useState(false);
  const [isActive16, setIsActive16] = useState(false);
  const [isActive18, setIsActive18] = useState(false);

  const handleFilter = (e, category) => {
    setActiveCategory(category);
    props.getVideos(e, category);
  };
  const handleAgeFilter = (e, category) => {
    setAgeCategory(e, category);
    props.getRatedVideos(e, category);
  };

  function handleContentRatingClick(e, category) {
    if (category === "7") {
      setIsActive7(!isActive7);
    } else if (category === "12") {
      setIsActive(!isActive);
    } else if (category === "16") {
      setIsActive16(!isActive16);
    } else if (category === "18") {
      setIsActive18(!isActive18);
    }
  
    // reset the state of the other buttons
    if (category !== "7") {
      setIsActive7(false);
    }
    if (category !== "12") {
      setIsActive(false);
    }
    if (category !== "16") {
      setIsActive16(false);
    }
    if (category !== "18") {
      setIsActive18(false);
    }
    props.getContent();
  }

  const handleChange = (event) => {
    setSortType(event.target.value);
  };
  return (
    <div className="App">
      <div className="GenreDiv">
        <div id="ContentCategory">
          <span>
            <button
              // className="genre-btn"
              onClick={(e) => handleFilter(e, "All")}
              className={`Genrelinks genre-btn ${
                props.genre.All === true ? "active" : ""
              }`}
              id="All"
              href="#"
            >
              All
            </button>
          </span>
          <span>
            <button
              
              onClick={(e) => handleFilter(e, "Education")}
              className={`Genrelinks genre-btn ${
                props.genre.Education === true ? "active" : ""
              }`}
              id="Education"
              href="#"
            >
              Education
            </button>
          </span>
          <span>
            <button
             
              onClick={(e) => handleFilter(e, "Sports")}
              className={`Genrelinks genre-btn ${
                props.genre.Sports === true ? "active" : ""
              }`}
              id="Sports"
              href="#"
            >
              Sports
            </button>
          </span>
          <span>
            <button
              
              onClick={(e) => handleFilter(e, "Comedy")}
              className={`Genrelinks genre-btn ${
                props.genre.Comedy === true ? "active" : ""
              }`}
              id="Comedy"
              href="#"
            >
              Comedy
            </button>
          </span>
          <span>
            <button
            
              onClick={(e) => handleFilter(e, "Lifestyle")}
              className={`Genrelinks genre-btn ${
                props.genre.Lifestyle === true ? "active" : ""
              }`}
              id="Lifestyle"
              href="#"
            >
              Lifestyle
            </button>
          </span>
          <span>
            <FormControl
              className={classes.formControl}
              style={{
                borderRadius: "20px",
                backgroundColor: "white",
                color: "white",
              }}
            >
              <Select value={sortType} onChange={handleChange} displayEmpty>
                <MenuItem value="">Sort By</MenuItem>
                <MenuItem
                  id={"release-date-option"}
                  onClick={props.getAccToRD}
                  value="release"
                  style={{ padding: "10px" }}
                >
                  Release by Date
                </MenuItem>
                <MenuItem id={"view-count-option"} onClick={props.getAccToVC} value="viewCount">
                  View Count
                </MenuItem>
              </Select>
            </FormControl>
          </span>
        </div>

        <div id="AgeCategory">
          <span>
            <button
             
              onClick={(e) => handleAgeFilter(e, "Anyone")}
              className={`Genrelinks content-rating-btn ${props.age.All === true ? "active" : ""}`}
              id="All"
              href="#"
            >
              All Age Group
            </button>
          </span>
          <span>
            <button
              onClick={(e) => {handleContentRatingClick(e, "7")}}
              className={`Genrelinks content-rating-btn ${
                isActive7 ? "active" : ""
              }`}
            >
              7+
            </button>
          </span>
          <span>
            <button
              onClick={(e) => {handleContentRatingClick(e, "12")}}
              className={`Genrelinks content-rating-btn ${
                isActive ? "active" : ""
              }`}
            >
              12+
            </button>
          </span>
          <span>
            <button
             onClick={(e) => {handleContentRatingClick(e, "16")}}
              className={`Genrelinks content-rating-btn ${
                isActive16 ? "active" : ""
              }`}
            >
              16+
            </button>
          </span>
          <span>
            <button
              onClick={(e) => {handleContentRatingClick(e, "18")}}
              className={`Genrelinks content-rating-btn ${
                isActive18 ? "active" : ""
              }`}
            >
              18+
            </button>
          </span>
        </div>
      </div>
    </div>
  );
}

export default Genre;
